module.exports = __webpack_public_path__ + "img/@tmp_hrdcloud_03.be19563b.jpg";